import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { ElementNode } from "lexical";

/** Serialized form of a layout container node. */

/** Converts a `div[data-lexical-layout-container]` into a layout container node. */
function convertLayoutContainerElement(domNode) {
  var template = domNode.style.gridTemplateColumns || window.getComputedStyle(domNode).getPropertyValue("grid-template-columns");
  return template ? {
    node: $createLayoutContainerNode(template)
  } : null;
}

/** Multi-column grid container for letter layouts. */
export var LayoutContainerNode = /*#__PURE__*/function (_ElementNode) {
  function LayoutContainerNode(templateColumns, key) {
    var _this;
    _classCallCheck(this, LayoutContainerNode);
    _this = _callSuper(this, LayoutContainerNode, [key]);
    _this.__templateColumns = templateColumns;
    return _this;
  }
  _inherits(LayoutContainerNode, _ElementNode);
  return _createClass(LayoutContainerNode, [{
    key: "createDOM",
    value: function createDOM() {
      var dom = document.createElement("div");
      dom.className = "grid gap-3";
      dom.style.gridTemplateColumns = this.__templateColumns;
      return dom;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM() {
      var element = document.createElement("div");
      element.setAttribute("data-lexical-layout-container", "true");
      element.className = "grid gap-3";
      element.style.gridTemplateColumns = this.__templateColumns;
      return {
        element: element
      };
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(prevNode, dom) {
      if (prevNode.__templateColumns !== this.__templateColumns) {
        dom.style.gridTemplateColumns = this.__templateColumns;
      }
      return false;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _superPropGet(LayoutContainerNode, "exportJSON", this, 3)([])), {}, {
        templateColumns: this.__templateColumns,
        type: "layout-container",
        version: 1
      });
    }
  }, {
    key: "isShadowRoot",
    value: function isShadowRoot() {
      return true;
    }
  }, {
    key: "canBeEmpty",
    value: function canBeEmpty() {
      return false;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "layout-container";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new LayoutContainerNode(node.__templateColumns, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(json) {
      return $createLayoutContainerNode(json.templateColumns);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        div: function div(domNode) {
          return domNode.hasAttribute("data-lexical-layout-container") ? {
            conversion: convertLayoutContainerElement,
            priority: 2
          } : null;
        }
      };
    }
  }]);
}(ElementNode);

/** Creates a layout container node. */
export function $createLayoutContainerNode() {
  var templateColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return new LayoutContainerNode(templateColumns);
}

/** Type guard for layout container nodes. */
export function $isLayoutContainerNode(node) {
  return node instanceof LayoutContainerNode;
}